<template>
  <v-card>
    <v-card-title>
      {{ $t("integrations.project_deployments.title") }}
    </v-card-title>
  </v-card>
</template>
<script>
import admin from "@/plugins/admin";

export default {
  props: ["id"],
  data() {
    return {
      version: null,
      last_modified: null
    };
  },
  created() {
    admin.http.get(`https://prominate.${this.id}.prominate-platform.com/api/status`).then(response => {
      this.version = response.body;
      this.last_modified = response.headers.get("last-modified");
    });
  }
};
</script>
